// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__tzGRX","ttl":"styles_ttl__jtAYr","txt":"styles_txt__kRjHt","btn":"styles_btn__5LqJG"};